export default {
      id: "clock-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.df848786.svg#clock",
      toString: function () {
        return this.url;
      }
    }